import React from 'react';
// Side-effect ponyfill: native `inert` is only in Chrome 102+/Safari 15.5+/FF 112+,
// but the supported-browser matrix includes older browsers where `inert` is a silent
// no-op (inactive drawer panels would stay focusable / AT-visible). wicg-inert
// activates only where native `inert` is absent and no-ops otherwise.
import 'wicg-inert';

import NavigationDrawer from '../components/NavigationDrawer';
import ErrorBoundary from '../components/ErrorBoundary';
import '../global-sass/drawer.scss';

/**
 * Widget entry point — renders NavigationDrawer inside an ErrorBoundary.
 * On render error: the boundary catches it, logs to console, and renders null.
 *
 * @returns {React.ReactElement}
 */
const Widget = () => (
	<ErrorBoundary>
		<NavigationDrawer />
	</ErrorBoundary>
);

export default Widget;
